import { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../lib/api';

export default function ForgotPassword() {
  const [email,   setEmail]   = useState('');
  const [loading, setLoading] = useState(false);
  const [sent,    setSent]    = useState(false);
  const [err,     setErr]     = useState('');

  const cardStyle = {
    maxWidth: 420, margin: '0 auto', marginTop: '8vh',
    background: 'var(--bg-card)', border: '1px solid var(--border)',
    borderRadius: 18, padding: '36px 32px', boxShadow: '0 2px 24px rgba(0,0,0,0.35)',
  };

  async function handleSubmit(e) {
    e.preventDefault();
    setErr('');
    setLoading(true);
    try {
      await api.post('/api/auth/forgot-password', { email });
      setSent(true);
    } catch {
      setErr('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-app)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: 24 }}>
      <div style={cardStyle}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 28 }}>
          <div className="logo-mark" style={{ width: 36, height: 36, fontSize: 14 }}>HF</div>
          <div>
            <div className="logo-name" style={{ fontSize: 15 }}>Helicon Flow</div>
            <div className="logo-sub" style={{ fontSize: 11 }}>Journey Viral</div>
          </div>
        </div>

        {sent ? (
          <>
            <div style={{ fontSize: 22, marginBottom: 8 }}>✉</div>
            <div style={{ fontSize: 17, fontWeight: 700, color: 'var(--tx-primary)', marginBottom: 10 }}>Check your email</div>
            <div style={{ fontSize: 13, color: 'var(--tx-secondary)', lineHeight: 1.6, marginBottom: 24 }}>
              If <strong>{email}</strong> is registered, you'll receive a password reset link shortly. The link expires in 1 hour.
            </div>
            <Link to="/login" style={{ fontSize: 12, color: 'var(--violet)', textDecoration: 'none' }}>
              ← Back to login
            </Link>
          </>
        ) : (
          <>
            <div style={{ fontSize: 17, fontWeight: 700, color: 'var(--tx-primary)', marginBottom: 6 }}>Forgot your password?</div>
            <div style={{ fontSize: 13, color: 'var(--tx-secondary)', marginBottom: 24, lineHeight: 1.5 }}>
              Enter your email and we'll send you a reset link.
            </div>

            {err && (
              <div style={{ padding: '10px 14px', background: 'rgba(212,85,85,0.12)', border: '1px solid rgba(212,85,85,0.3)', borderRadius: 8, fontSize: 12, color: 'var(--s-incomplete-t)', marginBottom: 16 }}>
                {err}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <label className="form-label">Email</label>
              <input
                className="form-input"
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="you@journeyviral.com"
                style={{ marginBottom: 20 }}
                required
                autoFocus
              />
              <button type="submit" className="btn-primary" style={{ width: '100%' }} disabled={loading}>
                {loading ? 'Sending…' : 'Send reset link'}
              </button>
            </form>

            <div style={{ marginTop: 16, textAlign: 'center' }}>
              <Link to="/login" style={{ fontSize: 12, color: 'var(--tx-muted)', textDecoration: 'none' }}>
                ← Back to login
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
